import { CustomerDataAddressInterface, CustomerDataRegionInterface } from 'swagger/ts/Definitions';

export function formToCustomerAddress(address?: { [index: string]: any }): CustomerDataAddressInterface | undefined {
    if (!address || !address.firstname || !address.lastname) {
        return undefined;
    }

    const { street1, street2, street, use_delivery, region_id, region, ...rest } = address;

    const output: CustomerDataAddressInterface = {
        ...rest,
        ...(getRegion(address) as any),
        ...getStreet(address),
        region_id,
    };

    return output;
}

function getStreet(input: { [index: string]: any }): { street: string[] } {
    const { street, street1, street2 } = input;
    if (Array.isArray(street) && street.every((x) => typeof x === 'string')) {
        return { street };
    }
    if (street1 && typeof street1 === 'string') {
        return { street: [street1, street2].filter(Boolean) as string[] };
    }
    console.warn('Could not create the street field');
    return { street: [] };
}

function getRegion(input: { [index: string]: any }): { region: CustomerDataRegionInterface } | undefined {
    if (input.region) {
        if (typeof input.region === 'string') {
            return { region: { region: input.region, region_code: input.region, region_id: 0 } };
        }
        if (typeof input.region.region === 'string') {
            return input.region;
        }
    }

    return undefined;
}
